import React, { HTMLInputTypeAttribute } from "react";
import { InputField } from "./input-field";
import { TextArea } from "./text-area";

export type InputType = (HTMLInputTypeAttribute | "textArea") | undefined;

export type InputFieldType = {
  label: string;
  type?: InputType;
  required: boolean;
  hover?: string;
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
  name: string;
};

export const InputFactory = (
  inputType: InputType
): React.ComponentType<any> => {
  switch (inputType) {
    case "textArea":
      return TextArea;
    default:
      return InputField;
  }
};
